import React from "react";
import AdminTabelHeader from "../../../components/layout/header/AdminTabelHeader";

const BottomMarque = () => {
  return (
    <div>
      <AdminTabelHeader
        title={"Bottom Marque"}
        btnStatus={true}
        btnname="Add"
        path="/admin/about/marquebottom/add"
      />
    </div>
  );
};

export default BottomMarque;
